import React, { FC } from "react";
import layoutStyles from "./childrenModeGreetingLayout.module.scss";
import styles from "./ChildrenModeHeroCityGreeting.module.scss";

type ChildrenModeHeroCityGreetingProps = {
  title: string;
  subTitle: string;
};

export const ChildrenModeHeroCityGreeting: FC<
  ChildrenModeHeroCityGreetingProps
> = ({ title, subTitle }) => (
  <div className={layoutStyles.root}>
    <p className={styles.text}>{title}</p>
    <p className={styles.text}>{subTitle}</p>
  </div>
);
